@if (projectReferences && projectReferences.length > 0) {
  <div class="grid-list">
    @for (reference of projectReferences; track trackByFn($index, reference)) {
      <div class="grid-list-item">
        <app-project-reference-grid-item [projectReference]="reference"></app-project-reference-grid-item>
      </div>
    }
  </div>
}
